import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDDropzone from "components/MDDropzone";
import MDAvatar from "components/MDAvatar";
import { useMemo } from "react";

export default function ImageField({ image , setImage, error}) {
    //Image upload handler
    const imageHandler = (file) => {
        setImage(file);
    }
    // Image remove handler
    const removeImageHandler = (file) => {
        setImage("");
    }
    return (

            <MDBox>
                <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                        Part's Picture
                    </MDTypography>
                </MDBox>
                {useMemo(
                    () => (
                        <MDDropzone
                            options={{ addRemoveLinks: true, maxFiles: 1 , acceptedFiles: 'image/*'}}
                            onFileAdd={imageHandler}
                            onFileRemove={removeImageHandler}
                            acceptedFiles="image/*"
                        />
                    ),
                    []
                )}
                {error.image && (
                    <MDTypography variant="caption" color="error" fontWeight="light">
                        {error.image}
                    </MDTypography>
                )}
            </MDBox>
            
    );
}